import React, { useEffect } from "react";

const GetQuote = () => {
  useEffect(() => {
    // Initialize ZenMaid
    window.zenmaid = window.zenmaid || [];
    function ztag(...args) {
      window.zenmaid.push(args);
    }
    ztag("js", new Date());
    ztag("config", "I1YVB");

    // Load ZenMaid script
    const script = document.createElement("script");
    script.src = "https://app.zenmaid.com/scripts/booking-form.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="relative pt-32 pb-20 bg-gradient-to-br from-cyan-400 via-cyan-500 to-navy-900 overflow-hidden">
        <div className="absolute inset-0 opacity-20">
          <div
            className="absolute inset-0"
            style={{
              backgroundImage: `repeating-linear-gradient(45deg, transparent, transparent 35px, white 35px, white 37px)`,
            }}
          ></div>
        </div>

        <div className="relative container mx-auto px-4 lg:px-8">
          <div className="max-w-4xl mx-auto text-center text-white">
            <div className="inline-block bg-white/20 backdrop-blur-sm border border-white/40 rounded-full px-6 py-2 mb-6">
              <span className="text-sm font-bold tracking-wide">
                FREE INSTANT QUOTE
              </span>
            </div>
            <h1 className="text-5xl md:text-7xl font-black leading-none mb-6">
              Get Your Free Quote
            </h1>
            <p className="text-xl md:text-2xl leading-relaxed">
              Fill out the form below and receive a personalized quote within 2
              hours
            </p>
          </div>
        </div>
      </section>

      {/* Form Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="max-w-7xl mx-auto">
            {/* Progress Benefits */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
              {[
                {
                  icon: "⚡",
                  title: "Quick Response",
                  desc: "Get your quote within 2 hours",
                },
                {
                  icon: "💰",
                  title: "No Hidden Fees",
                  desc: "Transparent, upfront pricing",
                },
                {
                  icon: "✓",
                  title: "No Obligation",
                  desc: "Free quote, no commitment",
                },
              ].map((item, index) => (
                <div
                  key={index}
                  className="text-center p-6 bg-gray-50 rounded-xl border-2 border-gray-200"
                >
                  <div className="text-4xl mb-3">{item.icon}</div>
                  <h3 className="text-lg font-bold text-navy-900 mb-2">
                    {item.title}
                  </h3>
                  <p className="text-gray-600 text-sm">{item.desc}</p>
                </div>
              ))}
            </div>

            {/* Booking Form */}
            <div className="zenmaid-container bg-white rounded-2xl shadow-2xl overflow-hidden border-2 border-gray-200 p-4" />

            {/* Contact Alternative */}
            <div className="mt-12 text-center">
              <div className="bg-gradient-to-br from-navy-900 to-navy-800 rounded-2xl p-8 text-white">
                <h3 className="text-2xl font-bold mb-4">
                  Prefer to Speak With Us?
                </h3>
                <p className="text-gray-300 mb-6">
                  Call us directly for an instant quote over the phone
                </p>
                <a
                  href="tel:03300545944"
                  className="inline-block px-8 py-4 bg-cyan-400 text-navy-900 font-bold text-lg rounded-xl hover:bg-cyan-500"
                >
                  CALL: 0330 054 5944
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default GetQuote;
